module.exports = __webpack_public_path__ + "static/08-90a020150a568b9bc39bfbad459fcda6.jpg";